import { PRINT_FORMS_BASE_URL } from 'shared/api/api';
import { authorizedRequest } from 'shared/api/axios';

export const fetchWccPrintForm = async (wccId: number, withStamp = false) => {
  const response = await authorizedRequest<void, string>(
    `${PRINT_FORMS_BASE_URL}/wcc/${wccId}?stamp=${withStamp ? 'true' : ''}`,
    'GET'
  );
  return response;
};

interface ExportFileResponse {
  id: string;
  fileName: string;
}

export const fetchWccExportXML = async (wccId: number): Promise<ExportFileResponse> => {
  const response = await authorizedRequest<ExportFileResponse, unknown>(
    `${PRINT_FORMS_BASE_URL}/wcc/${wccId}/export/xml`,
    'GET'
  );
  
  if (!response) {
    throw new Error('Пустой ответ от сервера');
  }
  
  return response as ExportFileResponse;
};


export const fetchTaxInvoicePrintForm = async (
  wccId: number,
  withSignature = false
) => {
  const response = await authorizedRequest<void, string>(
    `${PRINT_FORMS_BASE_URL}/tax-invoice/${wccId}?signature=${withSignature ? 'true' : ''}`,
    'GET'
  );
  return response;
};

export const fetchWccUpdInvoicePrintForm = async (
  wccId: number,
  withSignature = false
) => {
  const response = await authorizedRequest<void, string>(
    `${PRINT_FORMS_BASE_URL}/wcc-invoice/upd/${wccId}?signature=${withSignature ? 'true' : ''}`,
    'GET'
  );
  return response;
};

export const fetchPayrollPrintForm = async (
  salaryEntryId: number
) => {
  const response = await authorizedRequest<void, string>(
    `${PRINT_FORMS_BASE_URL}/payroll/${salaryEntryId}`,
    'GET'
  );
  return response;
};
